import { useState } from "react";
import { Globe2 } from "lucide-react";
import { REGIONS } from "@/hooks/useRegionalImages";

export const RegionSelector = ({ choice, choose, region, result, error }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="regional-imagery-controls">
    <label className="inline-flex items-center gap-2 rounded-lg border border-border px-3 py-1.5 text-xs text-muted-foreground">
      <Globe2 className="h-3.5 w-3.5 text-primary" /> Imagery
      <select value={choice} onChange={(e) => choose(e.target.value)} data-testid="region-override-selector" className="max-w-[150px] bg-transparent text-foreground outline-none cursor-pointer [&>option]:bg-card">
        <option value="auto">Browser hint</option>
        {Object.entries(REGIONS).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
      </select>
    </label>
    <p className="text-xs text-muted-foreground max-w-xs" role="status" data-testid="region-routing-status">
      {error ? "Regional images unavailable; showing default artwork." : !result ? "Loading imagery…" : `${REGIONS[region]}${choice === "auto" ? " · browser setting, not your exact location" : " · your choice"}${region !== "global" && Object.values(result.sources).some((s) => s === "global") ? " · default artwork where regional images aren't set" : ""}`}
    </p>
  </div>
);

export const RegionalHeroImage = ({ src, fallback, className, testId }) => {
  const [failed, setFailed] = useState(false);
  const [fallbackFailed, setFallbackFailed] = useState(false);
  if (fallbackFailed) return <div className="absolute inset-0 flex items-center justify-center text-emerald-300" data-testid={`${testId}-unavailable`}><Globe2 className="h-24 w-24" aria-label="Global hiring" /></div>;
  return <img src={failed ? fallback : src || fallback} onError={() => failed || !src ? setFallbackFailed(true) : setFailed(true)} alt="" aria-hidden="true" decoding="async" className={className} data-testid={testId} />;
};
